<template>
  <div v-show="Boolean(error)" class="partialErrorArea" :class="{ isPc: !isSp }">
    <p class="partialError">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: 'PartialErrorMessage',
  props: {
    error: {
      type: String,
      required: false,
      default: '',
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/css/contents/common/global';

.partialErrorArea {
  color: $color-red;
  font-size: $text-size-paragraph2;
  line-height: $text-line-height-default;

  &.isPc {
    margin-left: 124px;
  }

  .partialError {
    line-height: $text-line-height-default;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
